import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { UserService } from '../../services/user.service';
import { PartnerService } from '../../services/partner.service';
import { MainNavComponent } from '../main-nav/main-nav.component';
import { UtilityNavComponent } from '../utility-nav/utility-nav.component';
import { UserNavComponent } from '../user-nav/user-nav.component';
import { StateService } from '../../../products/services/state.service';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, MainNavComponent, UtilityNavComponent, UserNavComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  private userService = inject(UserService);
  unreadNews = this.userService.select('unreadNews');
  unreadMessages = this.userService.select('unreadMessages');
  isAuthenticated = this.userService.isAuthenticated;

  private parnerService = inject(PartnerService);
  readonly partner = this.parnerService.state.asReadonly();

  readonly printing = inject(StateService).isPrinting;
  
  constructor() { }
}
